

export const mobileScreen = '@media only screen and (max-width: 480px)'

export const largeMobileScreen = '@media only screen and (max-width: 600px)'

export const mobileDesign = '@media only screen and (max-width: 900px)'
export const tabletScreen = '@media only screen and (max-width: 1024px)'
